import { useContext, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import classes from './ExpensePage.module.scss';
import Expense from '../../../Components/pages/expense/Expense';
import { getExpense } from '../../../actions/expense';
import { getPlacements } from '../../../actions/constFromApi';
import { generalEnums } from '../../../utils/enums';
import { PageContext } from '../../../context/context';
import LoadingWithSpinner from '../../../Components/common/LoadingWithSpinner/LoadingWithSpinner';
import NoResults from '../../../Components/common/NoResults/NoResults';
import WarningImg from '../../../Assets/images/warning.svg';
import MainButton from '../../../Components/common/buttons/MainButton';
import { useWindowSize } from '../../../utils/hooks';
import { responsiveSizeTimesheet } from '../../../utils/constants';

export default function ExpensePage() {
  const params = useParams();
  const dispatch = useDispatch();
  const expense = useSelector((state) => state?.expense);
  const ctx = useContext(PageContext);
  const { t } = useTranslation();
  const size = useWindowSize();
  const navigate = useNavigate();

  useEffect(() => {
    ctx.setPageType(generalEnums.EXPENSE);
  }, [params, ctx]);

  useEffect(() => {
    dispatch(getExpense(params?.id, localStorage.getItem('UserId')));
  }, []);

  useEffect(() => {
    if (expense?.data?.ClientCompanyId) {
      dispatch(getPlacements(expense?.data?.ClientCompanyId));
    }
  }, [expense?.data?.ClientCompanyId]);

  if (expense?.isAccessDenied) {
    return (
      <div className={classes.wrapperContainer}>
        <NoResults
          isMobile={size.width < responsiveSizeTimesheet}
          icon={<img alt="warning" src={WarningImg} />}
          primaryTxt={t('common.errors.permission')}
          secondaryTxt={t('common.errors.permissionExpense')}
        >
          <MainButton rounded action={() => navigate('/dashboard')}>
            {t('common.actions.godashboard')}
          </MainButton>
        </NoResults>
      </div>
    );
  }

  return (
    <section className={classes.pageContainer}>{expense?.data?.Status ? <Expense /> : <LoadingWithSpinner />}</section>
  );
}
